import { useMemo } from 'react';

export const useListeningValidation = (quest, questData, selectedOptions, selectedMultipleOptions, selectedAnswers, value, isAudioPlaying) => {
  const hasValidUserResponse = useMemo(() => {
    if (!quest || !questData) {
      return false;
    }

    if (quest?.SubCategory === "Summarize Spoken Text" || quest?.SubCategory === "Write from Dictation") {
      return value?.trim() !== "";
    } else if (quest?.SubCategory === "Listening: Multiple Choice, Single Answer" || 
               quest?.SubCategory === "Highlight Correct Summary" || 
               quest?.SubCategory === "Select Missing Word") {
      return selectedOptions && selectedOptions !== "" && selectedOptions !== null && selectedOptions !== undefined;
    } else if (quest?.SubCategory === "Listening: Multiple Choice, Multiple Answers") {
      return selectedMultipleOptions?.length > 0;
    } else if (quest?.SubCategory === "Fill in the Blanks") {
      return questData && 
             questData?.AnswerNames?.length > 0 &&
             selectedOptions?.length === questData?.AnswerNames?.length && 
             selectedOptions?.every(answer => answer !== null && answer !== undefined && answer !== "");
    } else if (quest?.SubCategory === "Highlight Incorrect Words") {
      return selectedAnswers?.length > 0;
    }

    // Default case - if question type is not recognized, require some input
    return false;
  }, [quest?.SubCategory, questData, selectedOptions, selectedMultipleOptions, selectedAnswers, value]);

  const isNextButtonDisabled = isAudioPlaying || !hasValidUserResponse;

  return {
    isNextButtonDisabled,
    hasValidUserResponse: () => hasValidUserResponse,
  };
};
